var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddContract(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9732_24685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4998 32.0999C25.0381 32.0999 25.4897 31.9257 25.8545 31.5774C26.218 31.2291 26.3998 30.7857 26.3998 30.2474V26.3999H30.1998C30.7381 26.3999 31.1897 26.2175 31.5545 25.8527C31.918 25.4892 32.0998 25.0382 32.0998 24.4999C32.0998 23.9616 31.9256 23.51 31.5773 23.1452C31.2289 22.7817 30.7856 22.5999 30.2473 22.5999H26.3998V18.7999C26.3998 18.2616 26.218 17.81 25.8545 17.4452C25.4897 17.0817 25.0381 16.8999 24.4998 16.8999C23.9614 16.8999 23.5105 17.0741 23.147 17.4224C22.7822 17.7707 22.5998 18.2141 22.5998 18.7524V22.5999H18.7998C18.2614 22.5999 17.8105 22.7817 17.447 23.1452C17.0822 23.51 16.8998 23.9616 16.8998 24.4999C16.8998 25.0382 17.0739 25.4892 17.4223 25.8527C17.7706 26.2175 18.2139 26.3999 18.7523 26.3999H22.5998V30.1999C22.5998 30.7382 22.7822 31.1892 23.147 31.5527C23.5105 31.9175 23.9614 32.0999 24.4998 32.0999Z",
    fill: "#078DE7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9732_24685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddContract);
export default __webpack_public_path__ + "static/media/AddContract.2306bf2ae5dea1a33f490440fc8751a5.svg";
export { ForwardRef as ReactComponent };